/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_To_PrintInputs */

const en_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispatch to Print`)
};

const es_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar a Imprimir`)
};

const fr_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer à l'Impression`)
};

const de_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Druck senden`)
};

const ja_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印刷へ送信`)
};

const zh_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送打印`)
};

const ar_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إرسال للطباعة`)
};

const id_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim ke Percetakan`)
};

const it_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia alla Stampa`)
};

const ru_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить на Печать`)
};

const pt_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar para Impressão`)
};

const ko_dispatch_to_print = /** @type {(inputs: Dispatch_To_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인쇄소로 전송`)
};

/**
* | output |
* | --- |
* | "Dispatch to Print" |
*
* @param {Dispatch_To_PrintInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dispatch_to_print = /** @type {((inputs?: Dispatch_To_PrintInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_To_PrintInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_to_print(inputs)
	if (locale === "es") return es_dispatch_to_print(inputs)
	if (locale === "fr") return fr_dispatch_to_print(inputs)
	if (locale === "de") return de_dispatch_to_print(inputs)
	if (locale === "ja") return ja_dispatch_to_print(inputs)
	if (locale === "zh") return zh_dispatch_to_print(inputs)
	if (locale === "ar") return ar_dispatch_to_print(inputs)
	if (locale === "id") return id_dispatch_to_print(inputs)
	if (locale === "it") return it_dispatch_to_print(inputs)
	if (locale === "ru") return ru_dispatch_to_print(inputs)
	if (locale === "pt") return pt_dispatch_to_print(inputs)
	return ko_dispatch_to_print(inputs)
});